var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.checkPermission(["chartView_tuition_invoice"])
    ? _c("div", { staticClass: "card-wrapper" }, [
        _c("div", { staticClass: "card-top" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "card-heading" }, [
              _vm._m(0),
              _c("div", [
                _c("p", { staticClass: "card-title" }, [
                  _vm._v("Phiếu thu học phí"),
                ]),
                _c("p", { staticClass: "card-subtitle" }, [
                  _vm._v(
                    "Thống kê theo trạng thái học sinh trong năm " +
                      _vm._s(_vm.currentYear)
                  ),
                ]),
                _c("div", { staticClass: "header-tags" }, [
                  _c("span", { staticClass: "header-tag" }, [
                    _vm._v(_vm._s(_vm.selectedStatusLabel)),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "card-action" },
              [
                _c("span", { staticClass: "filter-label" }, [
                  _vm._v("Bộ lọc trạng thái"),
                ]),
                _c(
                  "el-select",
                  {
                    staticClass: "filter-select",
                    attrs: { placeholder: "Trạng thái", clearable: "" },
                    on: {
                      change: function ($event) {
                        return _vm.searchByPropertiesFees()
                      },
                    },
                    model: {
                      value: _vm.kidsStatus,
                      callback: function ($$v) {
                        _vm.kidsStatus = $$v
                      },
                      expression: "kidsStatus",
                    },
                  },
                  _vm._l(this.$funcData.getKidStatusAllList(), function (item) {
                    return _c("el-option", {
                      key: item.key,
                      attrs: { value: item.key, label: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.loaded && _vm.summaryCards.length
            ? _c(
                "div",
                { staticClass: "summary-row" },
                _vm._l(_vm.summaryCards, function (summary) {
                  return _c(
                    "div",
                    {
                      key: summary.label,
                      staticClass: "summary-card",
                      style: { "--summary-accent": summary.color },
                    },
                    [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v(_vm._s(summary.label)),
                      ]),
                      _c("strong", { staticClass: "summary-value" }, [
                        _vm._v(_vm._s(summary.value)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "chart-shell" }, [
          _vm.isLoading
            ? _c("div", { staticClass: "chart-content" }, [_vm._m(1)])
            : _vm.loaded && _vm.hasData
            ? _c("div", { staticClass: "chart-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "chartFees",
                    staticStyle: { "margin-top": "102px" },
                  },
                  [
                    _vm._m(2),
                    _c("ChartBar", {
                      attrs: {
                        checkLable: true,
                        chartData: _vm.dataConnection.chartData,
                        options: _vm.dataConnection.options,
                        height: 400,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _c("div", { staticClass: "chart-content chart-empty" }, [
                _vm._m(3),
              ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-icon" }, [
      _c("i", { staticClass: "el-icon-data-analysis" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--loading" }, [
      _c("i", { staticClass: "el-icon-loading state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Đang tải dữ liệu biểu đồ"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v("Hệ thống đang tổng hợp thống kê học phí mới nhất."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-caption" }, [
      _c("span", { staticClass: "chart-caption__dot" }),
      _c("span", [_vm._v("Biểu đồ cột so sánh theo từng trạng thái học sinh")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--empty" }, [
      _c("i", { staticClass: "el-icon-document-remove state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Chưa có dữ liệu phiếu thu học phí"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v(
            "Hãy thử đổi trạng thái học sinh hoặc kiểm tra lại dữ liệu nguồn."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }